// extracted by mini-css-extract-plugin
module.exports = {"image":"CardImage_image__b2xAE","noImage":"CardImage_noImage__JMzVF","notFound":"CardImage_notFound__DdL3h","notFoundText":"CardImage_notFoundText__DMshP"};